const previousLocation = (state = { previousLocation: null }, action) => {
  switch (action.type) {
    case 'UPDATE_PREVIOUS_LOCATION':
      return {
        ...state,
        previousLocation: action.previousLocation,
      };

    default:
      return state;
  }
};

export default previousLocation;

export const getPreviousLocation = (state) => state.previousLocation;
